import { Box, styled } from '@mui/material'

export const Container = styled(Box)(({ theme }) => ({
  position: 'fixed',
  zIndex: -1,
  width: '100%',
  height: '60%',
  top: '40%',
  bottom: 0,
  [theme.breakpoints.up('lg')]: {
    height: '100%',
    maxHeight: '1000px',
    top: 0,
    left: 0,
  },
  [theme.breakpoints.up(1800)]: {
    left: 'calc(50% - 900px)',
    maxWidth: '1800px',
  },
}))

export const OuterContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  '&::before, &::after': {
    background: 'linear-gradient(to right, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, 0))',
    content: '""',
    height: '100vh',
    width: 0,
    position: 'fixed',
    zIndex: 3,
    [theme.breakpoints.up(1800)]: {
      width: 'calc((100vw - 1600px)*0.5)',
    },
  },
  '&::before': {
    left: 0,
    top: 0,
  },
  '&::after': {
    right: 0,
    top: 0,
    transform: 'rotateZ(180deg)',
  },
}))
